import { DataAttributeDefinitions } from 'scrivito'

import { pisaContactDataClass } from './Pisa/pisaContactDataClass'

const attributes: DataAttributeDefinitions = {}

export const Contact = pisaContactDataClass(attributes)
